const s = (t, r) => {
  const e = t[r];
  return e ? typeof e == "function" ? e() : Promise.resolve(e) : new Promise((o, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(i.bind(null, new Error("Unknown variable dynamic import: " + r)));
  });
}, n = async (t) => {
  const { default: r } = await s(/* @__PURE__ */ Object.assign({ "./triggers/exit.js": () => import("./exit-ed362e0c.js"), "./triggers/pageOpen.js": () => import("./pageOpen-ff444fda.js"), "./triggers/pageViews2.js": () => import("./pageViews2-09b2d52e.js"), "./triggers/pageViews3.js": () => import("./pageViews3-9a97555e.js"), "./triggers/scroll50.js": () => import("./scroll50-b134dcb5.js"), "./triggers/timer10.js": () => import("./timer10-51dbdb27.js"), "./triggers/timer5.js": () => import("./timer5-37576f53.js"), "./triggers/timerIdle20.js": () => import("./timerIdle20-4005fe10.js") }), `./triggers/${t}.js`);
  return r;
};
export {
  n as default
};
